// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d303483f","223":"0754cb7d","301":"a2354045","573":"43695cb0","830":"f5764779","968":"2d1c59d4"}[chunkId] + ".chunk.js";
};